import type React from 'react'

const IconMinus: React.FC = () => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5.5C2 5.22386 2.22386 5 2.5 5H9.5C9.77614 5 10 5.22386 10 5.5V6.5C10 6.77614 9.77614 7 9.5 7H2.5C2.22386 7 2 6.77614 2 6.5V5.5Z"
      fill="currentColor"
    />
  </svg>
)

export default IconMinus
